import React from 'react';
import { Typography } from '@mui/material';

export type Company = 'ACORN' | 'CARROT' | 'MOTORCADE' | 'FLAG' | 'MYPOLICY' | 'STREETCOVER';

export type ErrorType = 'changeBankError' | 'changeOfPaymentDayError';

interface IManagedPaymentsErrorProps {
	company: Company;
	errorType: ErrorType;
}

const companyLinks: Record<Company, string> = {
	ACORN: 'https://www.acorninsure.co.uk/documents/change-of-bank-details/',
	CARROT: 'https://www.carrotinsurance.com/change-bank-details/',
	MOTORCADE: 'https://motorcade.co.uk/manage-your-payments/change-bank-details/',
	FLAG: 'https://www.flaginsurance.co.uk/help-and-support/',
	MYPOLICY: 'https://www.mypolicy.co.uk/get-in-touch/',
	STREETCOVER: 'https://www.streetcover.co.uk/contact-us/',
};

function getCompanyLink<T extends Company>(company: T): string {
	return companyLinks[company];
}

function getTypeErrorMessage<T extends ErrorType>(type: T, company: Company): React.ReactElement {
	const typeErrorMesages: Record<ErrorType, React.ReactElement> = {
		changeBankError: (
			<Typography
				variant='body2'
				sx={{
					margin: 'auto',
					textAlign: 'center',
					p: 2,
				}}
			>
				Your bank details cannot be changed more than once per policy term.
				<br />
				Please click &nbsp;
				<a href={getCompanyLink(company)}>here</a>
				<br />
				to contact our webchat team to discuss available payment management options.
			</Typography>
		),
		changeOfPaymentDayError: (
			<Typography
				variant='body2'
				sx={{
					margin: 'auto',
					textAlign: 'center',
					p: 2,
				}}
			>
				Your payment day cannot be changed more than once per policy term.
				<br />
				Please contact our webchat team to discuss available payment management options.
			</Typography>
		),
	};

	return typeErrorMesages[type];
}
const ManagedPaymentsError = ({ company, errorType }: IManagedPaymentsErrorProps) => {
	return getTypeErrorMessage(errorType, company);
};

export default ManagedPaymentsError;
